import { action, makeObservable, observable } from 'mobx';

import { ShopDetails, StoreDetails, UserAuthAttributes } from '../types/UserAuthTypes';
import { RootStore } from './RootStore';

export class UserAuthStore {
  public root: RootStore;
  public getUserLoginLoadingMaskPromise: Promise<void>;
  public shopSelectionResponse: ShopDetails = {
    shopDetailsList: [],
    userRole: '',
    error: '',
    statusCode: 0,
  };
  public userModel: UserAuthAttributes;
  public isLoggedIn = false;
  public videoCommerceOnboardingStatus = '';
  public isGetShopLoader = false;
  public currentStoreDetails: StoreDetails = null;
  public allStoreDetails: StoreDetails[] = [];

  constructor() {
    makeObservable(this, {
      root: false,
      isLoggedIn: observable,
      isGetShopLoader: observable,
      isLogged: action,
      isLoggedOut: action,
      shopSelectionResponse: observable,
      videoCommerceOnboardingStatus: observable,
      handleIsGetShopLoader: action,
      currentStoreDetails: observable,
      handleCurrentStoreDetails: action,
      allStoreDetails: observable,
      handleAllStoreDetails: action,
    });
  }

  public isLogged = () => {
    this.isLoggedIn = true;
  };

  public isLoggedOut = () => {
    this.isLoggedIn = false;
    localStorage.clear();
  };
  public handleIsGetShopLoader = (value: boolean) => {
    this.isGetShopLoader = value;
  };
  public handleCurrentStoreDetails = (value: StoreDetails) => {
    this.currentStoreDetails = value;
  };

  public handleAllStoreDetails = (storeDetailsList: StoreDetails[]) => {
    this.allStoreDetails = storeDetailsList;
  };
}

export const userAuthStore = new UserAuthStore();
